<template>
  <v-card class="dialog">
    <v-container class="ma-0 pa-0">
      <v-form ref="form" v-model="valid">
        <v-card-title class="primary px-4">
          <span v-if="page <= 1" class="headline"> SOLICITAR AJUDA</span>
          <span v-else class="headline"> SOLICITAÇÃO ENVIADA</span>
        </v-card-title>
        <v-card-text class="px-4">
          <v-layout column row v-if="page === 1">
            <v-layout wrap>
              <v-layout>
                <v-flex class="textModal" style=" " pb-3
                  >Gostaria de solicitar ajuda para um de nossos
                  analistas?</v-flex
                >
              </v-layout>
              <v-snackbar v-model="snack" :timeout="3500" :color="snackColor">
                {{ snackText }}
              </v-snackbar>
            </v-layout>
          </v-layout>
          <v-layout column row v-else-if="page === 2">
            <v-layout wrap>
              <v-layout>
                <v-flex class="textModal2" pb-3
                  >
                    {{returnMsg()}}
                </v-flex>
              </v-layout>
              <v-snackbar v-model="snack" :timeout="3500" :color="snackColor">
                {{ snackText }}
              </v-snackbar>
            </v-layout>
          </v-layout>
          <v-layout row justify-center>
          <v-dialog persistent v-model="dialogProgress" max-width="800px">
            <v-card class="dialog">
              <v-card-title class="primary">
                <span class="headline">ENVIANDO SOLICITAÇÃO</span>
              </v-card-title>
              <v-card-text >
                <div grid-list-md>
                  <v-layout wrap>
                    <v-flex align-center d-flex xs12>
                      <span>
                          Por favor, aguarde o processamento. Isso pode levar alguns segundos.
                      </span>
                    </v-flex>
                    <v-flex align-center d-flex xs12>
                      <v-progress-linear
                        heigth="2px"
                        indeterminate
                        color="primary"
                      ></v-progress-linear>
                    </v-flex>
                  </v-layout>
                </div>
              </v-card-text>

            </v-card>
          </v-dialog>
        </v-layout>
        </v-card-text>
        <v-card-actions class="px-4 pb-5">
          <v-layout row wrap>
            <v-flex class="special-flex" v-if="page === 1" offset-md4 md4 xs6>
              <v-btn  @click="fechar" class="btn-width-maior" flat color="primary">
                CANCELAR
              </v-btn>
            </v-flex>
            <v-flex md6 class="btn-mobile-special" xs12 v-else>
              <v-btn
                flat
               
                @click="voltarParaInicioQuestionario()"
                color="primary"
              >
                ABANDONAR COTAÇÃO
              </v-btn>
            </v-flex>
            <v-flex class="special-flex" v-if="page === 1" md4 xs6>
              <v-btn
                class="button-permanecer btn-width-maior" 
                @click=" enviarSolicitacaoAjuda()"
                flat
              >
                SIM
              </v-btn>
            </v-flex>
            <v-flex class="btn-mobile-special" md6 xs12 v-else>
              <v-btn class="button-permanecer2"  flat @click="fechar" >
                CONTINUAR PREENCHENDO
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-form>
    </v-container>
  </v-card>
</template>

<script>
import axios from "axios";

export default {
  name: "ModalSolicitarAjuda",

  data() {
    return {
      menu: false,
      snack: false,
      valid: false,
      snackColor: "",
      dadosCadastraisCliente: {},
      snackText: "",
      erroAjuda: null,
      dialogProgress: false,
      dialogError: false,
      errorMessage: "",
      errorDetails: null,
      page: 1,
      regras: {
        notNull: [
          v =>
            (v !== null && v !== undefined && v !== "") ||
            "Você não pode deixar este campo em branco"
        ]
      }
    };
  },

  props: {
    dialog: Boolean,
    dadosCadastrais: Object,
  },
  computed: {
    elementoPai: function() {
      return this.$parent;
    }
  },

  methods: {
    fechar() {
      this.$emit("fechar");
    },

    criarNovoCliente() {
      const dadosCadastrais = {
        razaoSocial: this.dadosCadastrais.dadosCadastrais.transportadora.nome,

        nome: this.dadosCadastrais.dadosCadastrais.usuario.nome,

        ddd: this.dadosCadastrais.dadosCadastrais.usuario.ddd,

        email: this.dadosCadastrais.dadosCadastrais.usuario.email,

        telefone: this.dadosCadastrais.dadosCadastrais.usuario.telefone,

        cnpj: this.dadosCadastrais.dadosCadastrais.transportadora.cnpj,

        cidade: this.dadosCadastrais.dadosCadastrais.transportadora.enderecos[0]
          .cidade,

        uf: this.dadosCadastrais.dadosCadastrais.transportadora.enderecos[0]
          .estado
      };
      return dadosCadastrais;
    },

    enviarSolicitacaoAjuda() {
      
      this.dialogProgress = true;
      axios
        .post(
          `${process.env.URL_QUESTIONARIOMS}/v1/no-auth/email-ajuda`,
          this.criarNovoCliente(),
          {
            headers: {}
          }
        )
        .then(() => {
          this.erroAjuda = 200;
          setTimeout(() => {
            this.dialogProgress = false;
            this.page = this.page + 1
            }, 1000);
        })
        .catch(error => {
          this.erroAjuda = 400;
        });
    },

    returnMsg() {
      if (this.erroAjuda == 200) {
        return "Certo! Já registramos seus dados e em breve entraremos em contato para auxiliar na cotação do seu seguro";
      } else {
        return "Erro ao tentar enviar seu e-mail de pedido de ajuda.. Entre em contato pelo Numero: (51) 2121 9000 no ramal 5704";
      }
    },

    voltarParaInicioQuestionario() {
      this.$router.go();
    },

    save() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Item salvo";
    }
  }
};
</script>

<style scoped>
.color {
  background-color: #eaeaea;
}

.headline {
  color: #fff;
  font-size: 14px !important;
}

.textModal {
  color: black;
  font-size: 16px;
  color: #646464; 
  text-align: left;
}

.textModal2 {
  color: black;
  font-size: 110%;
  text-align: left;
  font-weight: bolder;
}

.button-permanecer {
  background: #00456e;
  color: #fff !important;
}

.button-permanecer2 {
  background: #40bccc;
  color: #fff !important;
}
.special-flex {
  display: flex;
  justify-content: flex-end;
}

.btn-width-maior {
  width: 90%;
}
@media only screen and (max-width: 992px) {
  .btn-mobile-special {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
  }

}

</style>



// WEBPACK FOOTER //
// src/components/pages/questionario/ModalSolicitarAjuda.vue